module.exports = __webpack_public_path__ + "static/media/calendar.47ade866.svg";